module.exports = __webpack_public_path__ + "static/media/clock-counter-clockwise.d67670fb.svg";